/**
 * UniApp HTTP 适配器
 * 使用 uni.request 实现跨平台网络请求
 */

import type { HttpAdapter, HttpRequest, HttpResponse } from '../../../types/api'
import { ERROR_CODES } from '../../../constants/errors'
import { CsdError } from '../../../types/error'
import { joinBaseUrl } from '../../utils/url'

/**
 * 获取状态文本
 */
function getStatusText(statusCode: number): string {
  const statusTexts: Record<number, string> = {
    200: 'OK',
    201: 'Created',
    204: 'No Content',
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Not Found',
    500: 'Internal Server Error',
    502: 'Bad Gateway',
    503: 'Service Unavailable'
  }

  return statusTexts[statusCode] || 'Unknown'
}

/**
 * UniApp HTTP 适配器实现
 */
export const UniAppHttpAdapter: HttpAdapter = async <T = any>(
  config: HttpRequest
): Promise<HttpResponse<T>> => {
  return new Promise((resolve, reject) => {
    const fullUrl = joinBaseUrl(config.baseURL, config.url)

    uni.request({
      url: fullUrl,
      method: (config.method?.toUpperCase() || 'GET') as any,
      data: config.data as any,
      header: config.headers || {},
      timeout: config.timeout || 60000,
      success: (res: any) => {
        const response: HttpResponse<T> = {
          data: res.data as T,
          status: res.statusCode,
          statusText: getStatusText(res.statusCode),
          headers: res.header || {},
          config
        }
        if (res.statusCode >= 400) {
          reject(
            new CsdError(
              `HTTP Error: ${res.statusCode} ${getStatusText(res.statusCode)}`,
              ERROR_CODES.NETWORK_ERROR,
              response
            )
          )
          return
        }

        resolve(response)
      },
      fail: (err: any) => {
        const error = new Error(err.errMsg || '网络请求失败')
        ;(error as any).config = config
        ;(error as any).code = 'NETWORK_ERROR'
        reject(error)
      }
    })
  })
}
